<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Risk Matrix Definition</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">

    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
    <div class="card-body">
      <div class="row">

        <div class="col-12 mb-3" *ngIf="app.account.company_risk_matrix_url">
          <img
            [src]="app.account.company_risk_matrix_url"
            class="img-fluid border rounded"
            alt="Hierarchy of Controls Image" />
        </div>

        <div class="col-12">
          <button
            mat-raised-button
            color="secondary"
            type="button"
            class="my-1 ml-0 mr-3"
            (click)="onTriggerFileSelector($event)">

            <mat-icon>image</mat-icon>
            Select & Upload Image
          </button>

          <!-- Remove Button -->
          <button
            *ngIf="app.account.company_risk_matrix_url"
            mat-raised-button
            color="warn"
            type="button"
            class="my-1 ml-0 mr-3"
            (click)="onRemoveCompanyHierarchyOfControls()">

            <mat-icon>delete</mat-icon>
            Remove Image
          </button>
          <input type="file" (change)="onUploadSelectedFile($event)" style="display: none;" #fileInput />
        </div>

        <div class="col-12">
          <mat-hint>
            Only image files are allowed.
          </mat-hint>
        </div>
      </div>
    </div>
</mat-dialog-content>
